<template>
  <div class="filters">
    <div class="container">
      <div class="row">
        <div class="title" @click="show = !show" @click.stop="stopPropagation">
           <img
            class="title-down"
            v-if="role === 'superadmin'"
            src="../../images/dashboard/down-blue.png"
            alt="#"
          />
          <span class="drop-down-menu">{{ title[step] }}</span>
        </div>
        <transition name="router-anim">
          <ManagementList
            v-click-outside="closeModelList"
            @title="setTitle"
            v-if="show && role === 'superadmin'"
          ></ManagementList>
        </transition>
      </div>
    <div class="row filter-all">
        <div>
          <Search :steps="step"/>
        </div>
        <transition name="router-anim">
          <div  v-if="step === 0 || step === 4">
            <div class="filter-items">
              <div class="filter-wrap" v-click-outside="closeModel">
                <button
                  class="btn btn-filter"
                  :class="{ open: showFilters }"
                  @click="showFilters = !showFilters"
                >
                  Filter
                </button>
                <ul class="filter-list-wrap" v-show="showFilters">
                  <li class="filter-list-item hide">Status</li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(0, 'shipped')"
                    :class="{ active: shipped }"
                  >
                    Shipped
                  </li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(7, 'delivered')"
                    :class="{ active: delivered }"
                  >
                    Delivered
                  </li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(1, 'activated')"
                    :class="{ active: activated }"
                  >
                    Activated
                  </li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(2, 'awaiting')"
                    :class="{ active: awaiting }"
                  >
                    Submitted
                  </li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(3, 'received')"
                    :class="{ active: received }"
                  >
                    Lab Received
                  </li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(4, 'hold')"
                    :class="{ active: hold }"
                  >
                    On Hold
                  </li>

                  <li
                    class="filter-list-item"
                    @click="setFilter(5, 'complete')"
                    :class="{ active: complete }"
                  >
                    Analysis Complete
                  </li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(6, 'problem')"
                    :class="{ active: problem }"
                  >
                    Problematic Kits
                  </li>
                </ul>
              </div>
              <div class="datepickerWrapDiv">
                <Datepicker
                  placeholder="Date Fr1515om"
                  v-model="date_from"
                  :format="formatDate"
                  :disabledDates="disabledDatesFrom"
                  :calendar-class="{ calendarWrap: true }"
                  :class="{ datepickerWrapAdmin: true }"
                  :input-class="{ datepickerInputAdmin: true }"
                ></Datepicker>
                <img
                  src="../../images/dashboard/calendar.png"
                  alt="#"
                  class="datepickerWrapDiv-img"
                />
                <button
                  class="datepickerWrapDiv-img-cross"
                  v-if="date_from !== null"
                  @click="date_from = null"
                >
                  <CloseIcone></CloseIcone>
                </button>
              </div>
              <div class="datepickerWrapDiv">
                <Datepicker
                  placeholder="Date To"
                  v-model="date_to"
                  :format="formatDate"
                  :disabledDates="disabledDatesTo"
                  :calendar-class="{ calendarWrap: true }"
                  :class="{ datepickerWrapAdmin: true }"
                  :input-class="{ datepickerInputAdmin: true }"
                ></Datepicker>
                <img
                  src="../../images/dashboard/calendar.png"
                  alt="#"
                  class="datepickerWrapDiv-img"
                />
                <button
                  class="datepickerWrapDiv-img-cross"
                  v-if="date_to !== null"
                  @click="date_to = null"
                >
                  <CloseIcone></CloseIcone>
                </button>
              </div>
              <button
              v-if="role === 'superadmin' && step === 0"
                class="btn btn-test"
                @click="addTestKitModal"
                @click.stop="stopPropagation"
              >
                Add Test Kit555
              </button>
            </div>
            <div class="btn-filter-item-wrap-5">
              <button class="btn btn-filter-item" v-for="item in filters">
                <img
                  @click="resetStatusFilter(item)"
                  class="btn-filter-item-cross"
                  src="../../images/dashboard/cross.svg"
                  alt="#"
                />
                <span class="filter-item-txt" v-if="item === 0">Shipped</span>
                <span class="filter-item-txt" v-if="item === 1">Activated</span>
                <span class="filter-item-txt" v-if="item === 2">Submitted</span> 
                <span class="filter-item-txt" v-if="item === 3">Received</span>
                <span class="filter-item-txt" v-if="item === 4">Hold</span>
                <span class="filter-item-txt" v-if="item === 5">Complete</span>
                <span class="filter-item-txt" v-if="item === 6">Problematic</span>
                <span class="filter-item-txt" v-if="item === 7">Delivered</span>
              </button>
            </div>
          </div>
        </transition>
        <transition name="router-anim">
          <div class="filter-items" v-if="step === 1">
            <button
              class="btn btn-test"
              @click="addAdmin"
              @click.stop="stopPropagation"
            >
              Add Admin
            </button>
          </div>
        </transition>
        <transition name="router-anim">
          <div class="filter-items" v-if="step === 2">
            <button
              class="btn btn-test"
              @click="addLabOperator"
              @click.stop="stopPropagation"
            >
              Add Lab Operator
            </button>
          </div>
        </transition>
        <transition name="router-anim">
          <div class="filter-items" v-if="step === 22">
            <button
              class="btn btn-test"
              @click="addMtcLab"
              @click.stop="stopPropagation"
            >
              Add MTC Lab User
            </button>
          </div>
        </transition>
         <transition name="router-anim">
          <div v-if="step === 3" style="width:100%">
            <div class="filter-items">
              <p class="fix-header" v-if="analytics_header.type ==='visible_mold'">Visible mold - ({{analytics_header.sub_type}})</p>
              <p class="fix-header" v-if="analytics_header.type ==='musty_damp_odor'">Musty and damp odor - ({{analytics_header.sub_type}})</p>
              <p class="fix-header" v-if="analytics_header.type ==='symptoms'"> Symptoms - ({{analytics_header.sub_type}})</p>
              <div class="datepickerWrapDiv"  v-if="!analytics_header.button">
                <Datepicker
                  placeholder="Date From"
                  v-model="analytics_date_from"
                  :format="formatDate"
                  :disabledDates="disabledDatesFrom"
                  :calendar-class="{ calendarWrap: true }"
                  :class="{ datepickerWrapAdmin: true }"
                  :input-class="{ datepickerInputAdmin: true }"
                ></Datepicker>
                <img
                  src="../../images/dashboard/calendar.png"
                  alt="#"
                  class="datepickerWrapDiv-img"
                />
                <button
                  class="datepickerWrapDiv-img-cross"
                  v-if="analytics_date_from !== null"
                  @click="analytics_date_from = null"
                >
                  <CloseIcone></CloseIcone>
                </button>
              </div>
              <div class="datepickerWrapDiv"  v-if="!analytics_header.button">
                <Datepicker
                  placeholder="Date To"
                  v-model="analytics_date_to"
                  :format="formatDate"
                  :disabledDates="disabledDatesTo"
                  :calendar-class="{ calendarWrap: true }"
                  :class="{ datepickerWrapAdmin: true }"
                  :input-class="{ datepickerInputAdmin: true }"
                ></Datepicker>
                <img
                  src="../../images/dashboard/calendar.png"
                  alt="#"
                  class="datepickerWrapDiv-img"
                />
                <button
                  class="datepickerWrapDiv-img-cross"
                  v-if="analytics_date_to !== null"
                  @click="analytics_date_to = null"
                >
                  <CloseIcone></CloseIcone>
                </button>
              </div>
              <button
                v-if="analytics_header.button"
                class="btn btn-test"
                @click="showCount"
              >
                Back
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import moment from "moment";
import ManagementList from "../dashboard/ManagementList";
import CloseIcone from "../../images/shared/cancel";
import Search from "./search/Search";
export default {
  name: "Filters",
  props: ['steps'],
  data() {
    return {
      title: ["Test Kit Management", "Admin Management", "Lab Operator Management","Analytics","Outlier Kits"],
      step: 0,
      show: false,
      filters: [],
      showFilters: false,
      shipped: false,
      activated: false,
      awaiting: false,
      received: false,
      hold: false,
      complete: false,
      problem: false,
      delivered: false,
      showAddAdmin: false,
      date_from: null,
      date_to: null,
      analytics_date_from:null,
      analytics_date_to:null,
      analytics_header:{},
      disabledDatesTo: {
        to: null
      },
      disabledDatesFrom: {
        to: null
      }
    };
  },
  watch: {
    date_from(newDate) {
      this.disabledDatesTo = {
        to: this.date_from
      };
      if (newDate) {
        newDate = moment(newDate)
          .utc()
          .format("YYYY-MM-DD 00:01:00");
      }
      this.setDateFrom(newDate);
      if(this.steps.steps!='' && this.steps.steps == "4")
      {
        this.sendSearchReqPending();
        this.getPendingInfoList("pending").then(res => {
              this.$emit("title", { show: false, value: this.steps.steps });
            });
      }
    },
    date_to(newDate) {
      this.disabledDatesFrom = {
        from: this.date_to
      };
      if (newDate) {
        newDate = moment(newDate)
          .utc()
          .format("YYYY-MM-DD 23:59:00");
      }
      this.setDateTo(newDate);
      if(this.steps.steps!='' && this.steps.steps == "4")
      {
        this.sendSearchReqPending();
        this.getPendingInfoList("pending").then(res => {
              this.$emit("title", { show: false, value: this.steps.steps });
            });  
      }
    },
    analytics_date_from(newDate) {
      this.disabledDatesTo = {
        to: this.date_from
      };
      if (newDate) {
        newDate = moment(newDate)
          .utc()
          .format("YYYY-MM-DD 00:01:00");
      }
      this.setDateFromAnalytics(newDate);
    },
    analytics_date_to(newDate) {
      this.disabledDatesFrom = {
        from: this.date_to
      };
      if (newDate) {
        newDate = moment(newDate)
          .utc()
          .format("YYYY-MM-DD 23:59:00");
      }
      this.setDateToAnalytics(newDate);
    },
    getAnalyticsStatus(obj) {
      if(obj !=='undefined' || (obj.type !== 'undefined' && obj.item !== 'undefined') ){
          this.step = obj.status;
          this.show = obj.show;
          obj.item =  obj.item.toLowerCase().replace(/\b[a-z]/g, function(letter) {
                          return letter.toUpperCase();
                      });
          this.analytics_header = {type:obj.type,sub_type:obj.item,button:obj.show};
      } 
    },
    steps(val)
    {
      var obj = {};
      this.step = val;
      obj.value = 4;
      obj.show= false;
      if(val.value == "shipped")
      {
        var status = '';
        status = 0;
      }
      if(val.value == "activated")
      {
        var status = '';
        status = 1;
      }
      if(val.value == "awaiting")
      {
        var status = '';
        status = 2;
      }
      if(val.value == "received")
      {
        var status = '';
        status = 3;
      }

      if(val.value == "hold")
      {
        var status = '';
        status = 4;
      }
      if(val.value == "complete")
      {
        var status = '';
        status = 5;
      }
      if(val.value == "problematic")
      {
        var status = '';
        status = 6;
      }
      if(val.value == "delivered")
      {
        var status = '';
        status = 7;
      }
      this.setFilter(status,val.value);
      this.getPendingInfoList("pending").then(res => {
              this.$emit("title", { show: false, value: val.steps });
            });  
      this.setTitle(obj);
    }
  },
  computed: {
    ...mapGetters(["role","getAnalyticsStatus"])
  },
  methods: {
    ...mapActions([
      "setStatusFilter",
      "setProblemFilter",
      "setDateFrom",
      "setDateTo",
      "setDateToAnalytics",
      "setDateFromAnalytics",
      "sendSearchReq",
      "setAnalyticsHead",
      "getPendingInfoList",
      "sendSearchReqPending",

    ]),
    closeModelList() {
      this.show = false;
    },
    closeModel() {
      if (this.showFilters) {
        this.showFilters = !this.showFilters;
      }
    },
    formatDate(date) {
      return moment(date).format("MMM DD, YYYY");
    },
    addAdmin() {
      this.$emit("showAddAdminModal", true);
    },
    addLabOperator() {
      this.$emit("showAddLabOperatorModal", true);
    },
    addMtcLab() {
      this.$emit("showAddMtcLabModal", true);
    },
    setFilter(item, model) {
         //console.log(item);
         //console.log(model);
      this[model] = !this[model];
      const found = this.filters.indexOf(item);
      if(this.steps.steps!='' && this.steps.steps == "4")
      {
        this.filters.splice(found, 1);
      }
      if (found !== -1) {
        this.filters.splice(found, 1);
      } else {
        this.filters.push(item);
      }
      if(item == 6) {
        if(this.filters.includes(6)) {
          this.setProblemFilter(1);
        }else{
          this.setProblemFilter(null);
        }
      }else {
        this.setStatusFilter(this.filters);
      }
      if(this.steps.steps!='' && this.steps.steps == "4")
      {
        this.sendSearchReqPending();
      }  
      // } else {
      //   this.sendSearchReq();
      // }
    },
    resetStatusFilter(item) {
      switch (item) {
        case 0:
          this.shipped = false;
          break;
        case 1:
          this.activated = false;
          break;
        case 2:
          this.awaiting = false;
          break;
        case 3:
          this.received = false;
          break;
        case 4:
          this.hold = false;
          break;
        case 5:
          this.complete = false;
          break;
        case 6:
          this.problem = false;
          break;
        case 7:
          this.delivered = false;
          break;
        default:
          break;
      }

      const found = this.filters.indexOf(item);
      if (this.filters.length !== 0) {
        this.filters.splice(found, 1);
      } else {
        this.filters = null;
      }

      if(item == 6) {
        if(this.filters.includes(6)) {
          this.setProblemFilter(1);
        }else{
          this.setProblemFilter(null);
        }
      }else {
        this.setStatusFilter(this.filters);
      }
      
      if(this.steps.steps!='' && this.steps.steps == "4")
      {
        this.sendSearchReqPending();
        var obj = {};
        obj.value = 4;
        obj.show= false;
        this.getPendingInfoList("pending").then(res => {
              this.$emit("title", { show: false, value: this.steps.steps });
            }); 
            this.setTitle(obj); 
      }
    },
    addTestKitModal() {
      this.$emit("showTestKitModal", true);
    },
    setTitle(obj) {
      this.show = obj.show;
      this.step = obj.value;
      this.analytics_header = {type:null,sub_type:null,button:false};
      this.$emit("showComponent", obj.value);
    },
    stopPropagation(event) {
      event.stopPropagation();
    },
    showCount(){
      this.analytics_header = {type:null,sub_type:null,button:false};
      this.setAnalyticsHead({status:3,type:null,show:false});
    }
  },
  components: {
    ManagementList,
    Datepicker,
    CloseIcone,
    Search
  }
};
</script>

<style scoped>
.filter-all{
   top:35px;
}
.filters {
  margin: 45px 0 0 0;
}
.row {
  display: flex;
  justify-content: space-between;
  position: relative;
}
.title {
  color: #005eb8;
  font-size: 18px;
  font-family: TTNormsMedium, sans-serif;
  max-width: 250px;
  width: 100%;
  justify-content: space-between;
  margin: 10px 0 0 0;
  cursor: pointer;
}
.drop-down-menu {
  margin: 0px 0px 0px 5px; 
}
.title-down {
  height: 18px;
  cursor: pointer;
  vertical-align: top;
}
.filter-items {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: 1px solid transparent;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
  padding: 6px 15px 6px 15px;
  height: 30px;
  margin: 0 0 0 13px;
  cursor: pointer;
  border-radius: 5px;
}
.btn-filter-item {
  color: #fff;
  background-color: #ccc;
  cursor: default;
  margin: 0px 0 10px 13px;
}
.btn-more {
  width: 30px;
  height: 30px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 8px 7px;
}
.btn-row-item {
  display: flex;
  justify-content: space-between;
  max-width: 15px;
  width: 100%;
  margin: 2px 0;
}
.btn-point {
  background-color: #b3b3b3;
  width: 1px;
  height: 1px;
  border-radius: 100%;
}
.btn-row {
  background-color: #b3b3b3;
  width: 12px;
  height: 1px;
}
.btn-filter {
  background-color: #fff;
  color: #b3b3b3;
  border: 2px solid transparent;
  transition: all 0.5s linear;
}
.btn-filter.open {
  color: #005eb8;
  border: 2px solid #005eb8;
}
.btn-test {
  background-color: #005eb8;
  color: #fff;
  max-width: 128px;
  width: 100%;
}
.btn-filter-item-cross {
  max-width: 10px;
  height: auto;
  display: inline-block;
  margin: 0 10px 0 0;
  cursor: pointer;
}
.btn-filter-item-days {
  height: auto;
  display: inline-block;
  margin: 0 10px 0 0;
  cursor: pointer;
}
.filter-wrap {
  position: relative;
}
.filter-list-wrap {
  position: absolute;
  right: 0px;
  top: 35px;
  width: 160px;
  background-color: #fff;
  box-shadow: 0px 0px 5px 1px rgba(152, 164, 174, 0.4);
  z-index: 2;
}
.filter-list-item {
  padding: 10px;
  font-size: 13px;
  color: #000;
  font-family: TTNormsLight, sans-serif;
  transition: all 0.5s linear;
  cursor: pointer;
}
.filter-list-item:hover {
  background-color: #e0e9f4;
}
.filter-list-item.hide {
  padding: 10px;
  font-size: 12px;
  color: #b3b3b3;
  font-family: TTNormsMedium, sans-serif;
  cursor: default;
}
.filter-list-item.hide:hover {
  background-color: #fff;
}
.filter-list-item.active {
  font-family: TTNormsMedium, sans-serif;
  color: #005eb8;
}
.datepickerWrapDiv {
  position: relative;
}
.datepickerWrapDiv-img {
  position: absolute;
  left: 18px;
  top: 8px;
  max-width: 14px;
}
.btn-filter-item-wrap {
  max-width: 550px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
}
.btn-filter-item-wrap-5{
  max-width: 550px;
  width: 100%;
  display: flex;
  padding-top: 20px;
  align-items: center;
  flex-wrap: wrap;
}
.datepickerWrapDiv-img-cross {
  padding: 0;
  cursor: pointer;
  background-color: transparent;
  border: none;
  width: 11px;
  display: flex;
  align-self: center;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 10px;
  height: 11px;
}
.fix-header {
  color: #005eb8;
  font-size: 25px;
  font-family: TTNormsMedium, sans-serif;
  padding-right: 30%;
}
.header-center{
  text-align: center;
}
</style>